import { CAST_REVISION, profileSchema, type Profile, type UpdateProfile } from '@secretario/shared';
import { apiFetch } from './http.js';

// O app avisa que conhece o elenco atual (pacotes antigos recebem um personagem que conhecem).
const PROFILE_PATH = `/v1/profile?elenco=${CAST_REVISION}`;

export async function getProfile(): Promise<Profile> {
  return profileSchema.parse(await apiFetch<unknown>(PROFILE_PATH));
}

export async function patchProfile(patch: UpdateProfile): Promise<Profile> {
  return profileSchema.parse(
    await apiFetch<unknown>(PROFILE_PATH, { method: 'PATCH', body: patch }),
  );
}
